import styled from 'styled-components';

export const SpacerTop = styled.div``;
